// Anglais — Pages : tableau de bord, entrées, sorties, matrice, journal.
// Clé : le texte français exact de l'interface (voir lib/i18n.ts).
export const pages: Record<string, string> = {
  "État des flux en temps réel": "Live stream status",
  "Entrées en ligne": "Inputs online",
  "Sorties en service": "Outputs running",
  "Débit sortant": "Outgoing bitrate",
  "Connexions": "Connections",
  "Processeur": "CPU",
  "Mémoire": "Memory",
  "Aucune entrée": "No inputs",
  "Créer la première entrée": "Create the first input",
  "Gérer": "Manage",
  "gateway {cpu} % · {n} cœurs": "gateway {cpu} % · {n} cores",
  "{used} sur {total}": "{used} of {total}",
  "Une entrée reçoit un flux : un encodeur qui envoie en SRT ou RTMP, ou une caméra IP que la gateway va chercher.": "An input receives a stream: an encoder sending over SRT or RTMP, or an IP camera that the gateway pulls from.",
  "Flux reçus par la gateway": "Streams received by the gateway",
  "Créer une entrée": "Create an input",
  "État": "Status",
  "Entrée": "Input",
  "Type": "Type",
  "URL encodeur / source": "Encoder / source URL",
  "Visible par les opérateurs": "Visible to operators",
  "Détail": "Details",
  "Modifier": "Edit",
  "Supprimer l'entrée ?": "Delete the input?",
  "Entrée « {name} » supprimée": "Input “{name}” deleted",
  "client {name}": "client {name}",
  "Entrée « {name} » créée": "Input “{name}” created",
  "Entrée « {name} » modifiée": "Input “{name}” updated",
  "« {name} » alimente encore {outputs}. Supprimez ou réaffectez d'abord ces sorties.": "“{name}” still feeds {outputs}. Delete or reassign these outputs first.",
  "« {name} » sera supprimée et son encodeur déconnecté. Cette action est définitive.": "“{name}” will be deleted and its encoder disconnected. This cannot be undone.",
  "Retour aux entrées": "Back to inputs",
  "Encodeur déconnecté. Il peut se reconnecter.": "Encoder disconnected. It can reconnect.",
  "Déconnecter l'encodeur": "Disconnect the encoder",
  "Signal": "Signal",
  "Lecteurs": "Readers",
  "Encodeur": "Encoder",
  "Images en erreur": "Frames in error",
  "Pertes (1 s)": "Loss (1 s)",
  "Capacité du lien": "Link capacity",
  "Paquets perdus": "Packets lost",
  "Latence": "Latency",
  "Tampon": "Buffer",
  "Adresses": "Addresses",
  "À saisir dans l'encodeur :": "To enter in the encoder:",
  "L'URL de l'encodeur (avec sa clé) est visible par les opérateurs.": "The encoder URL (with its key) is visible to operators.",
  "Source récupérée par la gateway :": "Source pulled by the gateway:",
  "Lecture (VLC, ffplay, autre serveur) :": "Playback (VLC, ffplay, another server):",
  "Aucune sortie n'utilise cette entrée.": "No output uses this input.",
  "Journal de l'entrée": "Input event log",
  "Aucun événement.": "No events.",
  "Déconnecter l'encodeur ?": "Disconnect the encoder?",
  "Entrée « {id} » introuvable": "Input “{id}” not found",
  "{retrans} retransmis · {drop} abandonnés": "{retrans} retransmitted · {drop} dropped",
  "Sorties alimentées ({n})": "Outputs fed ({n})",
  "En ligne depuis {time}": "Online since {time}",
  "L'encodeur <ip>{publisher}</ip> sera coupé. S'il est réglé pour se reconnecter, il reviendra aussitôt ; les sorties passeront en attente entre-temps.": "The encoder <ip>{publisher}</ip> will be cut off. If it is set to reconnect, it will come straight back; outputs will wait in the meantime.",
  "Destinations alimentées par la gateway": "Destinations fed by the gateway",
  "Aucune sortie": "No outputs",
  "Créer une sortie": "Create an output",
  "Sortie": "Output",
  "Destination": "Destination",
  "Durée": "Uptime",
  "Relances": "Restarts",
  "Processeur (% du PC) et mémoire de la sortie": "CPU (% of the machine) and memory of the output",
  "Sur le secours": "On backup",
  "Accès client": "Client access",
  "estimé": "estimated",
  "Arrêter": "Stop",
  "Démarrer": "Start",
  "Habillage": "Overlay",
  "Logs": "Logs",
  "Arrêter la sortie ?": "Stop the output?",
  "Supprimer la sortie ?": "Delete the output?",
  "Sortie « {name} » démarrée": "Output “{name}” started",
  "Sortie « {name} » arrêtée": "Output “{name}” stopped",
  "Sortie « {name} » supprimée": "Output “{name}” deleted",
  "Une sortie renvoie une entrée vers une destination.": "An output sends an input to a destination.",
  "Créez d'abord une entrée.": "Create an input first.",
  "Une sortie renvoie une entrée vers une destination : CDN en SRT, YouTube en RTMP, multicast UDP…": "An output sends an input to a destination: a CDN over SRT, YouTube over RTMP, UDP multicast…",
  "source": "source",
  "secours": "backup",
  "pistes": "tracks",
  "piste": "track",
  "transcodage": "transcoding",
  "aucun client": "no clients",
  "1 client": "1 client",
  "{n} clients": "{n} clients",
  "Sortie « {name} » créée": "Output “{name}” created",
  "Sortie « {name} » modifiée et relancée": "Output “{name}” updated and restarted",
  "La diffusion vers « {name} » sera coupée. Elle ne redémarrera pas seule, même après un redémarrage du serveur.": "Streaming to “{name}” will stop. It will not restart by itself, even after a server restart.",
  "« {name} » sera arrêtée et supprimée. Cette action est définitive.": "“{name}” will be stopped and deleted. This cannot be undone.",
  "Matrice de routage": "Routing matrix",
  "Matrice vide": "Empty matrix",
  "Il faut au moins une entrée et une sortie pour router.": "At least one input and one output are needed for routing.",
  "Consultation : le routage est réservé aux opérateurs.": "View only: routing is reserved for operators.",
  "Déverrouillée : un clic change la source d'une sortie (coupure de quelques secondes).": "Unlocked: one click switches an output's source (a few seconds' interruption).",
  "Verrouillée : déverrouillez pour changer la source d'une sortie.": "Locked: unlock to switch an output's source.",
  "Verrouiller": "Lock",
  "Déverrouiller": "Unlock",
  "source de la sortie": "output source",
  "entrée diffusée en ce moment": "input currently on air",
  "Entrées ↓ · Sorties →": "Inputs ↓ · Outputs →",
  "Entrée de secours de cette sortie": "Backup input of this output",
  "Routée : {input} vers {output}": "Routed: {input} to {output}",
  "Secours : {input} vers {output}": "Backup: {input} to {output}",
  "Router : {input} vers {output}": "Route: {input} to {output}",
  "Alarmes et journal": "Alarms and event log",
  "Aucune alarme : tout fonctionne.": "No alarms: everything is working.",
  "Niveau": "Level",
  "Rechercher": "Search",
  "Rechercher…": "Search…",
  "Aucun événement ne correspond.": "No matching events.",
  "Info": "Info",
  "Alerte": "Warning",
  "Erreur": "Error",
  "sortie {id}": "output {id}",
  "Système": "System",
  "Auteur de l'action": "Author of the action",
  "par {user}": "by {user}",
  "Alarmes actives ({n})": "Active alarms ({n})",
  "Critique": "Critical",
  "depuis {duration}": "for {duration}",
  "Tout": "All",
  "Alertes et erreurs": "Warnings and errors",
  "Erreurs": "Errors",
  "Actions des utilisateurs": "User actions",
};
